angular.module('controllers')
    .component('gmBackToTop', {
        controller: 'backToTopController',
        template:  '<div>' +
            ' <button class = "{{$ctrl.style}}" ' +
            ' ng-class="$ctrl.startedScrolling" type="button" ng-click="$ctrl.goToTop()">' +
            '   <i id = "arrowIcon" aria-hidden="true" class="fa fa-chevron-up"></i>' +
            '</button>' +
            '</div>',
        bindings: {
            gmspeed: '<',
            gmstyle: '@'
        }
    })

    .controller('backToTopController', ['$window', '$scope', '$document', '$interval',
        function ($window, $scope, $document, $interval) {

            function didIReachTheTop() {
                return (this.pixelsScrolledToTop <= 500);
            }

            function returnVelocity() {
                var inc = Math.PI / (this.gmspeed / 10);
                var velocity = this.pixelsScrolledToTop * (0.5 - 0.5 * Math.cos(this.count * inc));
                return velocity;
            }

            function stopScrolling(scrollFn) {
                //this.window.scrollTo(0, 0);
                //console.log($('.fill-height').offset().top);
                //console.log('111');
                this.window.animate({ scrollTop: 0}, 'fast');
                //$('html, body').animate({ scrollTop: $(window.location.hash).offset().top}, 1000);
                this.interval.cancel(scrollFn);
            }

            function configDefaults() {
                this.style = this.gmstyle || "md-fab md-fab-bottom-right md-button md-ink-ripple docs-scroll-fab";
                this.gmspeed = this.gmspeed || 500;
            }

            var that = this;
            that.interval = $interval;
            // that.window = $window;
            that.window = angular.element( document.querySelector( '.fill-height' ));

            that.scope = $scope;
            that.pixelsScrolledToTop = 0;
            that.count = 0;

            configDefaults.call(that);
            that.startedScrolling = 'hideBackToTop';

            //that.window.addEventListener("scroll", function (event) {
            that.window.bind("scroll", function (event) {
                //console.log('999');
                that.pixelsScrolledToTop = angular.element(that.window).scrollTop();
                that.scope.$apply(function () {
                    that.startedScrolling = (that.pixelsScrolledToTop > 0 ? 'showBackToTop' : 'hideBackToTop');
                });
            });

            this.goToTop = function () {
                that.count = 0;
                (function scrollToTop() {
                    that.count++;
                    if (didIReachTheTop.call(that)) {
                        stopScrolling.call(that, scroll);
                    } else {
                        //console.log('333');
                        that.pixelsScrolledToTop -= returnVelocity.call(that);
                        window.scrollTo(0, that.pixelsScrolledToTop);
                        setTimeout(scrollToTop, 10);
                    }
                })();
            }
        }]);
